/**
 * AppSuiteProduct Molecule Component
 * Product block with name, description, and image for the App Suite section
 */

import React from 'react';
import { storyblokEditable } from '@/lib/blocks';
import { Heading } from '@/components/atoms/Heading';
import { Text } from '@/components/atoms/Text';
import { Image } from '@/components/atoms/Image';
import type { AppSuiteProductBlok } from '@/types';

export interface AppSuiteProductProps {
  blok: AppSuiteProductBlok;
  className?: string;
}

export const AppSuiteProduct: React.FC<AppSuiteProductProps> = ({ blok, className = '' }) => {
  const { name, description, image } = blok;

  return (
    <div
      {...storyblokEditable(blok)}
      className={`flex flex-col gap-6 md:gap-8 ${className}`}
    >
      {/* Product description */}
      <div className="flex flex-col gap-3 md:gap-4">
        <Heading level="h3" className="text-white text-xl md:text-2xl font-bold">
          {name}
        </Heading>
        <Text size="base" className="text-gray-300 leading-relaxed">
          {description}
        </Text>
      </div>

      {/* Product illustration */}
      {image?.filename && (
        <div className="w-full">
          <Image
            src={image.filename}
            alt={image.alt || name}
            className="w-full h-auto rounded-2xl"
          />
        </div>
      )}
    </div>
  );
};

export default AppSuiteProduct;
